export enum UserType {
  REGISTERED = 'Registered',
  SUBSCRIBED = 'Subscribed',
  ANONYMOUS = 'Anonymous',
  CANCELLED = 'Cancelled',
  VIP = 'Vip',
}
